import Vue from 'vue';
import Router from 'vue-router';
import Roll from '@/components/Roll';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Roll',
      component: Roll
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js